import Script from 'next/script';
import { FC, Fragment } from 'react';
import { Thing, WithContext } from 'schema-dts';

interface IJsonLdProps {
  /** Distinguishes this page's script tags from any others in the document. */
  id: string;
  /** One JSON-LD node, or several to emit as sibling `<script>` tags. */
  schema: WithContext<Thing> | Array<WithContext<Thing>>;
}

/**
 * Renders schema.org markup as `application/ld+json`, one `<script>` per node.
 * Sibling nodes are used rather than nesting because most schema.org types have
 * no property that accepts an arbitrary other type.
 */
export const JsonLd: FC<IJsonLdProps> = ({ id, schema }) => {
  const nodes = Array.isArray(schema) ? schema : [schema];

  return (
    <Fragment>
      {nodes.map((node, index) => (
        <Script
          // eslint-disable-next-line react/no-array-index-key
          key={`${id}-${index}`}
          id={`${id}-structured-data-${index}`}
          type="application/ld+json"
          strategy="beforeInteractive"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(node) }}
        />
      ))}
    </Fragment>
  );
};
